import httpClient from "./httpClient";

/** @returns {Promise<Array>} */
export const getAllCategories = async () => {
  const { data } = await httpClient.get("/category/all");
  return data.categories || [];
};
